import { getRoutingCandidateUsersRpc } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/RoutingCandidateUsersService';
import { chirpClient } from '../../shared/utils/chirp-client';
export const fetchRoutingUsersRpc = ({
  includeBots,
  objectTypeId,
  routingSource,
  specificUsers,
  workspaceId
}) => chirpClient.call(getRoutingCandidateUsersRpc, {
  request: {
    inboxId: workspaceId || undefined,
    includeBotUsers: !!includeBots,
    objectTypeId,
    routingSource: routingSource || undefined,
    specificUserIds: specificUsers
  }
});